import axios from 'axios';
import { ITariffEditProps } from '../interfaces/tariff';

export const getTariffsUrl = '/api/tariffs';
export const editTariffDiscountsUrl = (id: number) => `/api/tariff/${id}`;
export const editTariffPriceUrl = (id: number) => `/api/tariff_price/${id}`;
export const editTariffPeriodUrl = (id: number) => `/api/tariff_period/${id}`;

export const getTariffs = () => {
  return axios.get(`/api/tariffs`);
};

export const editTariff = (id: number, data: ITariffEditProps) =>
  axios.put(`api/tariff/${id}`, data);

export const buyTariffGem = async (id: number, days: number) =>
  axios.post(`/api/buy_tariff/${id}?days=${days}`);
